export interface InvoiceValidation {
  InvoiceId: number;
  WorkOrderPeriods: WorkOrderPeriodValidation[];
}

export interface WorkOrderPeriodValidation {
  WorkOrderId: number;
  WorkOrderNumber: string;
  WorkerName: string;
  PeriodStartDate: string; // ISO date string from backend
  PeriodEndDate: string;   // ISO date string from backend
  DisplayTimesheets: boolean;
  TimesheetDetails: TimesheetValidationDetail[];
  OtherTransactionCounts: TransactionTypeCount[];
}

export interface TimesheetValidationDetail {
  Id: number;
  InvoiceId?: number; // Present if timesheet is in another invoice
  StatusId: number;   // Maps to TimesheetValidationStatus enum
  TransactionId?: number; // Present if timesheet has a transaction
  StartDate: string;  // ISO date string
  EndDate: string;    // ISO date string
}

export interface TransactionTypeCount {
  TransactionTypeId: number; // Maps to TransactionType enum
  Count: number;
}

// Status enum matching backend
export enum TimesheetValidationStatus {
  Available = 1,   // Approved, has transaction, available for invoicing
  Unavailable = 2, // Approved, has transaction, but already in another invoice  
  Missing = 3      // Should exist for period but either no transaction or not approved
}
